import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle(props => {
  const { colorScheme: c } = props; // extract colorScheme from component props
  return {
    track: {
      _checked: {
        bg: mode(`${c}.300`, `${c}.500`)(props),
      },
    },
  };
});

export const switchTheme = defineMultiStyleConfig({ baseStyle });
